<script>
  import { Router } from "svelte-filerouter";
  import { fade } from "svelte/transition";
  import { subscriptionReady } from "./meteor.js";
  import Loader from "@/components/loaders/bookshelf.svelte";
  let installPrompt = false


  if ('serviceWorker' in navigator && window.location.hostname !== 'localhost') {
  // if ("serviceWorker" in navigator) {
    console.log("registering service worker");
    // navigator.serviceWorker.register("/service-worker.js?ts="+Date.now()).then(reg => {
    navigator.serviceWorker.register("/service-worker.js").then(reg => {
      reg.onupdatefound = () => {
        console.info({
          snack: {
            msg: "Klik for at opdatere til nyeste version",
            type: "success",
            fn: () => location.reload(),
            time: 0,
            closeable: true
          }
        });
      };
    });
    window.addEventListener("beforeinstallprompt", e => {
      installPrompt = e
      console.log('oooo install this app!!!!!!!!')
    });
  }
</script>



<main class="absolute inset-0">
  {#if $subscriptionReady}
    <Router scoped={{installPrompt}} />
  {:else}
    <div
      class="z-50 fixed inset-0 bg-orange-400 flex content-center justify-center
      flex-wrap"
      out:fade>
      <div>
        <div class="text-6xl text-white pb-6">Kontakter katalog</div>
        <Loader />
      </div>
    </div>
  {/if}
</main>
